import { uploadFileService } from '../_services';

export const uploadFileActions = {
  upload,
};

function upload(file, path) {
  return (_dispatch) => {
    uploadFileService.UploadFile(file, path);

    // dispatch({
    //     type: uploadFileConstants.UPDATE,
    //     // payload: !showForm,
    // });
  };
}
